import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { MessageService } from './message.service';
import { CustomerContract } from './customer-contract';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private customerGuid;
  private customer: CustomerContract;
  private url = 'api/customers';  // URL to web api
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private cookieService: CookieService,
    private http: HttpClient,
    private messageService: MessageService
  ) {

    this.customerGuid = this.getCustomerGuidCookieValue();

    if (this.customerGuid) {
      this.getCustomer(this.customerGuid)
        .subscribe(result => this.customer = result);
    }
  }

  public setCustomerGuid(guid: string) {
    this.customerGuid = guid;
    this.cookieService.set('customer-guid', guid, new Date(2030, 1), null, null, true, "Strict")
  }

  public getCustomerGuid(): string {
    return this.customerGuid;
  }

  public isAuthenticated(): Observable<boolean> {

    if (this.customerGuid == undefined || this.customerGuid == '')
      return of(false);

    if (this.customer != undefined) {
      return of(true);
    }

    return this.getCustomer(this.customerGuid)
      .pipe(map(customer => customer != undefined));
  }

  private getCustomerGuidCookieValue(): string {
    return this.cookieService.get('customer-guid');
  }

  private getCustomer(guid: string): Observable<CustomerContract> {
    return this.http.get<CustomerContract>(this.url + "/" + guid, this.httpOptions)
      .pipe(
        retry(3)
      );
  }
}
